import { ChangeEventHandler, Ref } from 'react'
import useStyles from './styles'
import { InputAttrs, InputComponent, TextareaAttrs } from './types'
import { useStateStyles } from './utils'

export const Input: InputComponent = props => {
  const {
    label,
    value,
    placeholder,
    required,
    validated,
    multiline = false,
    error,
    disabled,
    onChange,
    inputProps,
    icon,
    errorMessage,
    styles: overrides,
    rows = 1,
    inputRef,
    fullWidth = false,
  } = props
  const styles = useStyles({
    hasIcon: Boolean(icon),
    hasLabel: Boolean(label),
    fullWidth,
  })
  const {
    errorStyles,
    validatedStyles,
    dataEnteredStyles,
    disabledStyles,
  } = useStateStyles({
    validated,
    error,
    disabled,
    value,
    styles,
    overrides,
  })

  return (
    <div css={[styles.root, overrides?.root]} className="hero-input__root">
      <div
        css={[
          styles.wrapper,
          overrides?.wrapper,
          ...dataEnteredStyles,
          ...validatedStyles,
          ...errorStyles,
          ...disabledStyles,
        ]}
        className="hero-input__wrapper"
      >
        <label css={styles.inputBox} className="hero-input__inputBox">
          {multiline ? (
            <textarea
              className="hero-input__input"
              data-testid="hero-input"
              rows={rows}
              {...(inputProps as TextareaAttrs)}
              css={[styles.input, overrides?.input]}
              placeholder={placeholder}
              required={required}
              value={value}
              onChange={onChange as ChangeEventHandler<HTMLTextAreaElement>}
              ref={inputRef as Ref<HTMLTextAreaElement>}
              disabled={disabled || false}
            />
          ) : (
            <input
              className="hero-input__input"
              type="text"
              data-testid="hero-input"
              {...(inputProps as InputAttrs)}
              css={[styles.input, overrides?.input]}
              placeholder={placeholder}
              required={required}
              value={value}
              onChange={onChange as ChangeEventHandler<HTMLInputElement>}
              ref={inputRef as Ref<HTMLInputElement>}
              disabled={disabled || false}
            />
          )}
        </label>
        <label
          css={[styles.label, overrides?.label]}
          className="hero-input__label"
        >
          {label}
        </label>
        <span css={[styles.icon, overrides?.icon]}>{icon && icon}</span>
      </div>

      {error && (
        <p
          css={[styles.errorMessage, overrides?.errorMessage]}
          className="hero-input__errorMessage"
        >
          {errorMessage}
        </p>
      )}
    </div>
  )
}
